import { Component } from '@angular/core';
import { HeaderComponent } from '../../shared/header/header.component';
import { FooterComponent } from '../../shared/footer/footer.component';
import { RouterOutlet } from '@angular/router';
import { SidebarService } from '../../services/sidebar.service';
import { CommonModule } from '@angular/common';
import { SideBarComponent } from '../../shared/side-bar/side-bar.component';

@Component({
  selector: 'top-technology-main',
  standalone: true,
  imports: [CommonModule, SideBarComponent, HeaderComponent, FooterComponent, RouterOutlet],
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss'
})
export class MainComponent {
  isSidebarOpen = true;

  constructor(
    private sidebarService: SidebarService
  ) {
    this.sidebarService.collapsed$.subscribe(isOpen => {
      this.isSidebarOpen = isOpen;
    });
  }
}
